import { FC } from 'react';
import { Button } from '@components/atoms/Button';
import { Input } from '@components/atoms/Input';
import { FormGroup } from '@components/molecules/form/FormGroup';
import { PasswordRequirements } from '@components/molecules/PasswordRequirements';
import { useTranslation } from '@hooks/useTranslation';

type PasswordFormProps = {
  values: { oldPassword: string; newPassword: string };
  errors: { oldPassword?: string; newPassword?: string };
  touched: { oldPassword?: boolean; newPassword?: boolean };
  isSubmitting: boolean;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
};

export const PasswordForm: FC<PasswordFormProps> = ({
  values,
  errors,
  touched,
  isSubmitting,
  handleSubmit,
  handleChange,
  handleBlur,
}) => {
  const tSettings = useTranslation('settings');
  return (
    <form className="mt-10 max-w-xl space-y-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormGroup
          label={tSettings.oldPassword}
          htmlFor="oldPassword"
          error={touched.oldPassword ? (errors.oldPassword as string) : ''}>
          <Input
            id="oldPassword"
            name="oldPassword"
            type="password"
            placeholder={tSettings.enterOldPassword}
            value={values.oldPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>
        <FormGroup
          label={tSettings.newPassword}
          htmlFor="newPassword"
          error={touched.newPassword ? (errors.newPassword as string) : ''}>
          <Input
            id="newPassword"
            name="newPassword"
            type="password"
            placeholder={tSettings.enterNewPassword}
            value={values.newPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormGroup>
      </div>
      <PasswordRequirements value={values.newPassword} />
      <Button type="submit" loading={isSubmitting}>
        {tSettings.updatePasswordButton}
      </Button>
    </form>
  );
};

export default PasswordForm;
